(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('isomorphic-unfetch')) :
  typeof define === 'function' && define.amd ? define(['exports', 'isomorphic-unfetch'], factory) :
  (global = global || self, factory(global.utilihiveHttp = {}, global.isomorphicUnfetch));
})(this, (function (exports, fetch) {
  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var fetch__default = /*#__PURE__*/_interopDefaultLegacy(fetch);

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    return _extends.apply(this, arguments);
  }

  function _catch(body, recover) {
    try {
      var result = body();
    } catch (e) {
      return recover(e);
    }

    if (result && result.then) {
      return result.then(void 0, recover);
    }

    return result;
  }

  var errorCodes = {
    HTTP_RESPONSE_INVALID_CONTENT_TYPE: 'HTTP_RESPONSE_INVALID_CONTENT_TYPE',
    HTTP_RESPONSE_STATUS_NOT_2XX: 'HTTP_RESPONSE_STATUS_NOT_2XX',
    HTTP_RESPONSE_STATUS_UNAUTHORIZED: 'HTTP_RESPONSE_STATUS_UNAUTHORIZED'
  };

  var getErrorCodeForHTTPStatusCode = function getErrorCodeForHTTPStatusCode(statusCode) {
    switch (statusCode) {
      case 401:
        return errorCodes.HTTP_RESPONSE_STATUS_UNAUTHORIZED;

      default:
        return errorCodes.HTTP_RESPONSE_STATUS_NOT_2XX;
    }
  };

  var mockFetch = function mockFetch(url, options) {
    try {
      return Promise.resolve(options && options.body && JSON.parse(options.body));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var setMock = function setMock(mockFetchFunction) {
    if (mockFetchFunction === void 0) {
      mockFetchFunction = mockFetch;
    }

    if (typeof window === 'undefined') {
      global.METERCLOUD_FRONTEND_HTTP_MOCK = mockFetchFunction;
    } else {
      window.METERCLOUD_FRONTEND_HTTP_MOCK = mockFetchFunction;
    }
  };

  var getMock = function getMock() {
    return typeof window === 'undefined' ? global.METERCLOUD_FRONTEND_HTTP_MOCK : window.METERCLOUD_FRONTEND_HTTP_MOCK;
  };

  var tryToParseAsJsonResponse = function tryToParseAsJsonResponse(response) {
    try {
      var contentTypeHeader = response.headers.get('Content-Type');

      if (!contentTypeHeader || contentTypeHeader.indexOf('application/json') !== 0) {
        throw new Error(errorCodes.HTTP_RESPONSE_INVALID_CONTENT_TYPE);
      }

      return Promise.resolve(response.json());
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var checkStatusCode = function checkStatusCode(response, returnErrorMessage) {
    try {
      var _temp4 = function _temp4() {
        throw error;
      };

      if (response.ok) {
        return Promise.resolve();
      }

      var error = new Error(getErrorCodeForHTTPStatusCode(response.status));

      var _temp5 = function () {
        if (returnErrorMessage) {
          var _temp6 = _catch(function () {
            return Promise.resolve(tryToParseAsJsonResponse(response)).then(function (serverError) {
              if (serverError.message) {
                error = new Error(serverError.message);
              }
            });
          }, function () {});

          if (_temp6 && _temp6.then) return _temp6.then(function () {});
        }
      }();

      return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(_temp4) : _temp4(_temp5));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var fetchJSON = function fetchJSON(url, options) {
    if (options === void 0) {
      options = {};
    }

    try {
      var _options = options,
          _options$method = _options.method,
          method = _options$method === void 0 ? 'GET' : _options$method,
          body = _options.body,
          _options$stringifyBod = _options.stringifyBody,
          stringifyBody = _options$stringifyBod === void 0 ? true : _options$stringifyBod,
          token = _options.token,
          _options$parseResult = _options.parseResult,
          parseResult = _options$parseResult === void 0 ? true : _options$parseResult,
          _options$returnErrorM = _options.returnErrorMessage,
          returnErrorMessage = _options$returnErrorM === void 0 ? true : _options$returnErrorM,
          contentType = _options.contentType,
          headers = _options.headers;

      var mappedOptions = _extends({
        headers: _extends({
          'Content-Type': contentType || 'application/json',
          Accept: 'application/json'
        }, token && {
          Authorization: "Bearer " + token
        }, headers),
        method: method
      }, body && {
        body: stringifyBody ? JSON.stringify(body) : body
      });

      var mock = getMock();

      if (mock) {
        return Promise.resolve(mock(url, mappedOptions));
      }

      var fetchFn = typeof window === 'undefined' ? fetch__default["default"] : fetch__default["default"].bind();
      return Promise.resolve(fetchFn(url, mappedOptions)).then(function (response) {
        return Promise.resolve(checkStatusCode(response, returnErrorMessage)).then(function () {
          return parseResult ? tryToParseAsJsonResponse(response) : response;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var get = fetchJSON;
  var post = function post(url, options) {
    return fetchJSON(url, _extends({
      method: 'POST'
    }, options));
  };
  var put = function put(url, options) {
    return fetchJSON(url, _extends({
      method: 'PUT'
    }, options));
  };
  var del = function del(url, options) {
    return fetchJSON(url, _extends({
      method: 'DELETE',
      parseResult: false
    }, options));
  };

  exports.checkStatusCode = checkStatusCode;
  exports.del = del;
  exports.errorCodes = errorCodes;
  exports.get = get;
  exports.mockFetch = mockFetch;
  exports.post = post;
  exports.put = put;
  exports.setMock = setMock;

}));
